#import "../fragments/landing-page-stub-fragment.graphql"

mutation DeleteLandingPage($input: PageDeleteInput!) {
    pageDelete(input: $input) {
        page {
            ...LandingPageStubFragment
        }
    }
}
